import { Component, input, ViewChild, AfterViewInit, computed, viewChild, TemplateRef, effect } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";

@Component({
  selector: "app-validation-history-table",
  standalone: false,
  templateUrl: "./validation-history-table.component.html",
  styleUrl: "./validation-history-table.component.scss",
})
export class ValidationHistoryTableComponent {
  validationHistory = input.required<Array<any>>();

  columnsConfig = input.required<Array<{ columnDef: string; header: string; cell: (element: any) => string }>>();

  paginator = input<MatPaginator>();

  searchTerm = input<string>();

  customCellTpl = input<Record<string, TemplateRef<any>>>();

  sort = viewChild(MatSort, { read: MatSort });

  dataSource = computed(() => {
    if (!this.validationHistory()) {
      return;
    }
    const source = new MatTableDataSource(this.validationHistory());

    if (this.searchTerm()) {
      source.filter = this.searchTerm();
    }

    if (this.paginator()) {
      source.paginator = this.paginator();
    }

    source.sort = this.sort();
    source.sortingDataAccessor = (item, property) => {
      switch (property) {
        case "date":
          return new Date(item.date);
        case "profiles":
          return item.schema;
        case "businessRules":
          return item.bizrule;
        default:
          return item[property];
      }
    };
    return source;
  });

  columnDef = computed(() => {
    return this.columnsConfig().map((column) => column.columnDef);
  });

  get displayedColumns() {
    return this.columnDef();
  }

  get columns() {
    return this.columnsConfig();
  }

  get customTemplates() {
    return this.customCellTpl();
  }

  constructor() {}
}
